<app-loader [type]="'overlaidSpinner'" [overlayType]="'light'" />
